import { Box } from '@mui/material';
import * as Preact from 'preact';
import * as ProductImage from './A_ProductImageSmall';

export interface Props {
    loading: boolean;
    selectedOption?: string;
    options: {
        id: string;
        image: string;
        type: string;
    }[];
    onClick: (id: string) => void;
}

export const Component = (p: Props) => {
    return (
        <Box
            sx={{
                backgroundColor: '#F7F7F7',
                overflowX: 'auto',
                overflowY: 'hidden',
                scrollbarWidth: 'thin',
            }}
        >
            <Box
                sx={{
                    width: 'fit-content',
                    margin: '0 auto',
                    display: 'flex',
                    gap: '12px',
                    padding: '12px',
                }}
            >
                {p.options.map(option => (
                    <ProductImage.Component
                        id={option.id}
                        image={option.image}
                        loading={p.loading && p.selectedOption === option.id}
                        disabled={p.loading}
                        selected={!p.loading && p.selectedOption === option.id}
                        onClick={() => p.onClick(option.id)}
                    />
                ))}
            </Box>
        </Box>
    );
};

Component.displayName = 'BottomSelectionContainer';
